import React from 'react'

import { SecondaryNavLayout } from 'src/modules/ui'

import CreateInvoice from './CreateInvoice'
import EditInvoice from './EditInvoice'
import InvoiceList from './InvoiceList'
import ViewInvoice from './ViewInvoice'

const Invoices = () => {
  const routes = [
    {
      navLabel: 'Sent',
      path: `/invoices/list`,
      render: props => <InvoiceList />,
    },
    {
      navLabel: 'New',
      path: `/invoices/new`,
      render: props => <CreateInvoice />,
    },
    {
      path: `/invoices/:id/edit`,
      component: EditInvoice,
      title: 'Edit Invoice',
    },
    {
      path: `/invoices/:id`,
      component: ViewInvoice,
      title: 'Invoice',
    },
  ]

  return <SecondaryNavLayout routes={routes} />
}
export default Invoices
